import type { Editor } from "@tiptap/react";

/** Dictated words get a space before them unless the cursor starts a line or follows one. */
const needsLeadingSpace = (editor: Editor): boolean => {
  const before = editor.state.selection.$from.nodeBefore;
  if (!before) return false;
  if (before.isText) return !/\s$/.test(before.text ?? "");
  return before.type.name !== "hardBreak";
};

/**
 * Inserts accepted dictation at the cursor of a TipTap editor and focuses it.
 * A text node, not a string: insertContent would parse a string as HTML.
 */
export const insertDictatedText = (editor: Editor, text: string): void => {
  editor
    .chain()
    .focus()
    .insertContent({
      type: "text",
      text: needsLeadingSpace(editor) ? ` ${text}` : text,
    })
    .run();
};
